module.exports = __webpack_public_path__ + "media/src/components/Header/logo_2x-2a1cd29fe9ed145df2d45c769f3acf4e.png";